import React from 'react';
import { Edit3, X, Save, Palette, Type, Image as ImageIcon } from 'lucide-react';
import { Button } from '../ui/button';
import { useEditor } from '../../contexts/EditorContext';
import { useLocation } from 'react-router-dom';

const EditorToolbar = () => {
  const { isEditorMode, isAdmin, toggleEditorMode } = useEditor();
  const location = useLocation();

  // Don't show in admin area at all
  const isAdminArea = location.pathname.startsWith('/admin');
  
  if (!isAdmin || isAdminArea) return null;

  return (
    <div
      className={`fixed top-20 sm:top-4 right-2 sm:right-4 z-50 transition-all rounded-lg shadow-xl p-2 sm:p-3 border-2 hidden sm:block ${
        isEditorMode 
          ? 'bg-gradient-to-r from-blue-600 to-purple-600 border-blue-400' 
          : 'bg-gradient-to-r from-[#6D5A47] to-[#8B7355] border-[#C4A084]'
      } text-white max-w-[calc(100vw-1rem)] sm:max-w-none`}
    >
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3">
        {isEditorMode ? (
          <>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              <span className="text-xs sm:text-sm font-semibold">Editor-Modus aktiv</span>
            </div>
            <Button
              size="sm"
              variant="ghost"
              onClick={toggleEditorMode}
              className="text-white hover:bg-blue-800 hover:text-white"
            >
              <X className="h-4 w-4 mr-1" />
              Beenden
            </Button>
            <a href="/admin/visual-design">
              <Button
                size="sm"
                variant="outline"
                className="text-white border-white/30 hover:bg-white/10 hover:text-white hover:border-white/50"
              >
                Zum Editor
              </Button>
            </a>
          </>
        ) : (
          <>
            <a href="/admin/visual-design">
              <Button
                size="sm"
                variant="ghost"
                className="text-white hover:bg-[#8B7355] hover:text-white text-xs sm:text-sm w-full sm:w-auto"
              >
                <Edit3 className="h-3 w-3 sm:h-4 sm:w-4 mr-1" />
                Design bearbeiten
              </Button>
            </a>
            <a href="/admin">
              <Button
                size="sm"
                variant="outline"
                className="text-white border-[#C4A084] hover:bg-[#8B7355] hover:text-white hover:border-[#E8C4A8] text-xs sm:text-sm w-full sm:w-auto"
              >
                Zum Admin
              </Button>
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default EditorToolbar;
